import {
  Flex,
  HStack,
  Heading,
  IconButton,
  Image,
  Text,
} from "@chakra-ui/react";
import { LuMenu } from "react-icons/lu";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "@/shared/session";

export const MOBILE_TOPBAR_HEIGHT = "56px";

interface MobileTopBarProps {
  onOpenMenu: () => void;
}

export const MobileTopBar = ({ onOpenMenu }: MobileTopBarProps) => {
  const { user, session } = useAuth();
  const currentZone = user?.zones.find((zone) => zone.id === session?.zone);

  return (
    <Flex
      as="header"
      display={{ base: "flex", lg: "none" }}
      align="center"
      gap={2}
      h={MOBILE_TOPBAR_HEIGHT}
      px={3}
      bg="bg.sidebar"
      color="fg"
      borderBottomWidth="1px"
      borderColor="border"
      position="sticky"
      top={0}
      zIndex={20}
      flexShrink={0}
    >
      <IconButton
        aria-label="Abrir menú"
        variant="ghost"
        color="fg.muted"
        _hover={{ bg: "bg.muted", color: "fg" }}
        onClick={onOpenMenu}
      >
        <LuMenu />
      </IconButton>
      <RouterLink to="/" aria-label="Ir al inicio">
        <HStack gap={2}>
          <Image
            src="/stocks-logo.svg"
            alt="Geslub Stocks"
            boxSize="30px"
            objectFit="contain"
          />
          <Heading
            as="span"
            size="sm"
            lineHeight="1"
            letterSpacing="wider"
            textTransform="uppercase"
            aria-label="Geslub Stocks"
          >
            Stocks
          </Heading>
        </HStack>
      </RouterLink>
      {currentZone && (
        <Text ms="auto" fontSize="xs" color="fg.muted" truncate maxW="40%">
          {currentZone.name}
        </Text>
      )}
    </Flex>
  );
};
